import * as Yup from 'yup';

export default Yup.object().shape({
  email: Yup.string()
    .email('Digite um e-mail válido')
    .required('Campo obrigatório'),
});
